export function hasExtensionError(error) {
    var _a;
    try {
        return ((_a = error) === null || _a === void 0 ? void 0 : _a.extensions) !== undefined;
    }
    catch (_b) {
        return false;
    }
}
export const convertErrorToTypedError = (type, error) => {
    const isError = error instanceof Error;
    const message = isError ? error.message : 'Unknown error.';
    const extensions = hasExtensionError(error) ? error.extensions : undefined;
    const typedError = {
        type,
        message,
        extensions,
    };
    return typedError;
};
//# sourceMappingURL=convert-error-to-typed-error.js.map